import { makeStyles } from "@material-ui/core";
import colors from "Styles/colors";

type StyleProps = {
  width?: number;
};

const useStyles = makeStyles(({ palette }) => ({
  tooltip: {
    maxWidth: ({ width }: StyleProps) => width || 230,
    margin: 6,
    padding: 16,
    color: colors.black,
    backgroundColor: colors.white,
    borderWidth: 0.5,
    borderRadius: 4,
    borderColor: palette.grey[200],
    boxShadow: `0 8px 16px 0 ${palette.grey[300]}`,
  },
}));

export default useStyles;
